import { render, staticRenderFns } from "./FullscreenBlock.vue?vue&type=template&id=b144df54&"
import script from "./FullscreenBlock.vue?vue&type=script&lang=js&"
export * from "./FullscreenBlock.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports